export enum WalletServiceKeys {
  CHECK_PHONE_NUMBER = 'WALLET_CHECK_PHONE_NUMBER',
}
